export enum AssignmentFilterType {
	PICKUP,
	DELIVERY,
	ALL
}